import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Stack,
  Fade,
} from '@mui/material';
import { LocalFlorist, Spa, EmojiNature } from '@mui/icons-material';

const AboutSection = () => {
  return (
    <Box
      id="about"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: 'background.paper',
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <Fade in timeout={1000}>
          <Stack spacing={6}>
            {/* Section Header */}
            <Stack spacing={2} alignItems="center">
              <Typography
                variant="overline"
                sx={{
                  color: 'primary.main',
                  fontWeight: 600,
                  letterSpacing: '0.2em',
                }}
              >
                Discover
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2rem', md: '3rem' },
                  fontWeight: 700,
                  textAlign: 'center',
                }}
              >
                Our Story
              </Typography>
              <Box
                sx={{
                  width: 60,
                  height: 3,
                  bgcolor: 'primary.main',
                  borderRadius: 2,
                }}
              />
            </Stack>

            {/* Content Grid */}
            <Grid container spacing={4} className='grid-w mt-20'>
              <Grid item xs={12} md={6} className='grid-cst'>
                <Stack spacing={3}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 600,
                      color: 'primary.main',
                      lineHeight: 1.3,
                    }}
                  >
                    Veda and Vine is a celebration of ancient wisdom woven into modern indulgence.
                    Rooted in the timeless knowledge of the Vedas and nourished by nature’s finest
                    offerings, our brand brings you thoughtfully curated laddoos crafted with organic
                    ingredients, premium dry fruit blends, and revered Ayurvedic herbs.
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                    Each creation is a harmonious blend of taste and well-being—infused with powerful
                    ancient herbs like Shilajit and Shatavari, known for their restorative and
                    balancing properties. At Veda and Vine, we believe nourishment should be both
                    wholesome and delightful, where tradition meets conscious living.
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                    Our delicacies are handcrafted with care, free from shortcuts, and inspired by
                    generations of healing practices. More than just sweets, they are mindful
                    indulgences—designed to energize the body, calm the mind, and reconnect you
                    with nature’s wisdom.
                  </Typography>
                  <Typography variant="h5" color="text.primary" sx={{ lineHeight: 1.2 }}>
                    Veda and Vine — where heritage is savoured, and wellness is tasted.
                  </Typography>
                </Stack>
              </Grid>

              <Grid item xs={12} md={6} className='grid-cst'>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 4,
                        marginBottom:2,
                        borderRadius: 3,
                        background: 'linear-gradient(135deg, #F8F6F1 0%, #E8E3D8 100%)',
                      }}
                    >
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Box className="icon-circle"
                          sx={{
                            width: 60,
                            height: 60,
                            borderRadius: '50%',
                            bgcolor: 'primary.main',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <LocalFlorist sx={{ color: 'white', fontSize: 32 }} />
                        </Box>
                        <Box>
                          <Typography variant="h6" fontWeight={600}>
                            Ancient Wisdom
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Rooted in 5,000 years of Ayurvedic tradition
                          </Typography>
                        </Box>
                      </Stack>
                    </Paper>
                  </Grid>

                  <Grid item xs={12}>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 4,
                        marginBottom:2,
                        borderRadius: 3,
                        background: 'linear-gradient(135deg, #F8F6F1 0%, #E8E3D8 100%)',
                      }}
                    >
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Box className="icon-circle"
                          sx={{
                            width: 60,
                            height: 60,
                            borderRadius: '50%',
                            bgcolor: 'primary.main',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Spa sx={{ color: 'white', fontSize: 32 }} />
                        </Box>
                        <Box>
                          <Typography variant="h6" fontWeight={600}>
                            Modern Practices
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Integrated with contemporary wellness science
                          </Typography>
                        </Box>
                      </Stack>
                    </Paper>
                  </Grid>

                  <Grid item xs={12}>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 4,
                        marginBottom:2,
                        borderRadius: 3,
                        background: 'linear-gradient(135deg, #F8F6F1 0%, #E8E3D8 100%)',
                      }}
                    >
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Box className="icon-circle"
                          sx={{
                            width: 60,
                            height: 60,
                            borderRadius: '50%',
                            bgcolor: 'primary.main',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <EmojiNature sx={{ color: 'white', fontSize: 32 }} />
                        </Box>
                        <Box>
                          <Typography variant="h6" fontWeight={600}>
                            Holistic Approach
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Nurturing mind, body, and spirit in harmony
                          </Typography>
                        </Box>
                      </Stack>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Stack>
        </Fade>
      </Container>
    </Box>
  );
};

export default AboutSection;
